export interface ReceiptTripDownloadArgs {
  id: number;
  trip_id: number;
  invoice_id: number | null;
  invoice_number: string | null;
  organization_name: string;
  total_price: number;
  receipt_status: string | null;
  receipt_status_text: string | null;
  receipt_flag: string | null;
  receipt_flag_text: string | null;
  receipt_record_id: number;
  receipt_number: string | null;
  receipt_issue_date: string;
  user_id: number;
  user_name: string;
  email: string;
  name: string;
  receipt_amount: number;
  include_price_breakdown: boolean;
  include_fee: boolean;
  price_remarks_type_text: string | null;
  file_path: string | null;
}

export default class ReceiptTripDownload {
  public id: number;
  public tripId: number;
  public invoiceId: number | null;
  public invoiceNumber: string | null;
  public organizationName: string;
  public totalPrice: number;
  public receiptStatus: string | null;
  public receiptStatusText: string | null;
  public receiptFlag: string | null;
  public receiptFlagText: string | null;
  public receiptRecordId: number;
  public receiptNumber: string | null;
  public receiptIssueDate: string;
  public userId: number;
  public userName: string;
  public email: string;
  public name: string;
  public receiptAmount: number;
  public includePriceBreakdown: boolean;
  public includeFee: boolean;
  public priceRemarksTypeText: string | null;
  public filePath: string | null;

  constructor(args: ReceiptTripDownloadArgs) {
    this.id = args.id;
    this.tripId = args.trip_id;
    this.invoiceId = args?.invoice_id;
    this.invoiceNumber = args?.invoice_number;
    this.organizationName = args.organization_name;
    this.totalPrice = args.total_price;
    this.receiptStatus = args.receipt_status;
    this.receiptStatusText = args.receipt_status_text;
    this.receiptFlag = args.receipt_flag;
    this.receiptFlagText = args.receipt_flag_text;
    this.receiptRecordId = args.receipt_record_id;
    this.receiptNumber = args?.receipt_number;
    this.receiptIssueDate = args.receipt_issue_date;
    this.userId = args.user_id;
    this.userName = args.user_name;
    this.email = args.email;
    this.name = args.name;
    this.receiptAmount = args.receipt_amount;
    this.includePriceBreakdown = args.include_price_breakdown;
    this.includeFee = args.include_fee;
    this.priceRemarksTypeText = args?.price_remarks_type_text;
    this.filePath = args?.file_path;
  }
}
